export default __webpack_public_path__ + "static/media/Mordechai.bb18ad9c.jpg";